var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import '@bit/smartworks.unity.unity-core/unity-popover';
export default class UnityPopover extends Component {
    constructor() {
        super(...arguments);
        this._popoverRef = React.createRef();
        this.componentDidMount = () => {
            this.updateProperties();
        };
        this.componentDidUpdate = (oldProps) => {
            this.updateProperties(oldProps);
        };
        this.updateProperties = (oldProps = {}) => {
            const { _popoverRef, props: { onClose, fallbackPlacements, boundary, referenceElement, offsetModifier } } = this;
            const { current } = _popoverRef;
            if (!!current) {
                if (!!onClose && onClose !== oldProps.onClose)
                    current.onClose = onClose;
                if (!!fallbackPlacements && fallbackPlacements !== oldProps.fallbackPlacements)
                    current.fallbackPlacements = fallbackPlacements;
                if (!!boundary && boundary !== oldProps.boundary)
                    current.boundary = boundary;
                if (!!referenceElement && referenceElement !== oldProps.referenceElement)
                    current.referenceElement = referenceElement;
                if (!!offsetModifier && offsetModifier !== oldProps.offsetModifier)
                    current.offsetModifier = offsetModifier;
            }
        };
    }
    render() {
        const _a = this.props, { withClose, show, closeOnOutsideClick, flip, preventOverflow, placement, onPageContent, popoverContent, offsetModifier } = _a, otherProps = __rest(_a, ["withClose", "show", "closeOnOutsideClick", "flip", "preventOverflow", "placement", "onPageContent", "popoverContent", "offsetModifier"]);
        const boolProps = {};
        if (withClose)
            boolProps.withClose = withClose;
        if (show)
            boolProps.show = show;
        if (closeOnOutsideClick)
            boolProps.closeOnOutsideClick = closeOnOutsideClick;
        if (flip)
            boolProps.flip = flip;
        if (preventOverflow)
            boolProps.preventOverflow = preventOverflow;
        delete otherProps.onClose;
        delete otherProps.fallbackPlacements;
        delete otherProps.boundary;
        delete otherProps.referenceElement;
        return (React.createElement("unity-popover", Object.assign({ ref: this._popoverRef, placement: placement }, boolProps, otherProps),
            !!onPageContent && React.createElement("div", { slot: 'on-page-content' }, onPageContent),
            React.createElement("div", { slot: 'popover-content' }, popoverContent)));
    }
}
